/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const CommitteeUsers = {

	deleteUser (context, committeeUserId, onSuccess, onError, options) {
		Api.delete(context,
			"/committee-users/user"
			+ "?committeeUserId=" + committeeUserId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getCommitteeUsersAvailable (context, committeeId, onSuccess, onError, options) {
		Api.get(context,
			"/committee-users/committee-users-available"
			+ "?committeeId=" + committeeId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getUsers (context, committeeId, onSuccess, onError, options) {
		Api.get(context,
			"/committee-users/users"
			+ "?committeeId=" + committeeId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getUsersToAdd (context, committeeId, onSuccess, onError, options) {
		Api.get(context,
			"/committee-users/users-to-add"
			+ "?committeeId=" + committeeId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postPromoteToLeader (context, committeeUserId, onSuccess, onError, options) {
		Api.post(context,
			"/committee-users/promote-to-leader"
			+ "?committeeUserId=" + committeeUserId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putUser (context, committeeId, userId, onSuccess, onError, options) {
		Api.put(context,
			"/committee-users/user"
			+ "?committeeId=" + committeeId
			+ "&userId=" + userId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
